import { Injectable } from '@angular/core';
import { CookieConsentService } from './cookie-consent.service';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  
  constructor(private cookieConsentService: CookieConsentService) {}

  // localStorage methods
  setLocalItem(key: string, value: string): void {
    if (this.cookieConsentService.areCookiesEnabled()) {
      localStorage.setItem(key, value);
    } else {
      console.warn('Cookies rejeitados: localStorage.setItem() ignorado');
    }
  }

  getLocalItem(key: string): string | null {
    if (this.cookieConsentService.areCookiesEnabled()) {
      return localStorage.getItem(key);
    } else {
      console.warn('Cookies rejeitados: localStorage.getItem() ignorado');
      return null;
    }
  }

  removeLocalItem(key: string): void {
    if (this.cookieConsentService.areCookiesEnabled()) {
      localStorage.removeItem(key);
    } else {
      console.warn('Cookies rejeitados: localStorage.removeItem() ignorado');
    }
  }

  clearLocalStorage(): void {
    if (this.cookieConsentService.areCookiesEnabled()) {
      localStorage.clear();
    } else {
      console.warn('Cookies rejeitados: localStorage.clear() ignorado');
    }
  }

  // sessionStorage methods
  setSessionItem(key: string, value: string): void {
    if (this.cookieConsentService.areCookiesEnabled()) {
      sessionStorage.setItem(key, value);
    } else {
      console.warn('Cookies rejeitados: sessionStorage.setItem() ignorado');
    }
  }

  getSessionItem(key: string): string | null {
    if (this.cookieConsentService.areCookiesEnabled()) {
      return sessionStorage.getItem(key);
    } else {
      console.warn('Cookies rejeitados: sessionStorage.getItem() ignorado');
      return null;
    }
  }

  removeSessionItem(key: string): void {
    if (this.cookieConsentService.areCookiesEnabled()) {
      sessionStorage.removeItem(key);
    } else {
      console.warn('Cookies rejeitados: sessionStorage.removeItem() ignorado');
    }
  }

  clearSessionStorage(): void {
    if (this.cookieConsentService.areCookiesEnabled()) {
      sessionStorage.clear();
    } else {
      console.warn('Cookies rejeitados: sessionStorage.clear() ignorado');
    }
  }

  // Cookie methods
  setCookie(name: string, value: string, days?: number): void {
    if (this.cookieConsentService.areCookiesEnabled()) {
      let expires = '';
      if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = '; expires=' + date.toUTCString();
      }
      document.cookie = name + '=' + value + expires + '; path=/';
    } else {
      console.warn('Cookies rejeitados: setCookie() ignorado');
    }
  }

  getCookie(name: string): string | null {
    if (this.cookieConsentService.areCookiesEnabled()) {
      const nameEQ = name + '=';
      const ca = document.cookie.split(';');
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
      }
      return null;
    } else {
      console.warn('Cookies rejeitados: getCookie() ignorado');
      return null;
    }
  }

  deleteCookie(name: string): void {
    if (this.cookieConsentService.areCookiesEnabled()) {
      document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    } else {
      console.warn('Cookies rejeitados: deleteCookie() ignorado');
    }
  }
} 